<template>
  <v-card
    flat
    class="ma-3 pa-6"
  >
    <v-row align="center" class="pl-0 mb-6 pt-3 pr-3">
      <v-card-title>
        Websites
      </v-card-title>
      <v-spacer></v-spacer>
      <v-text-field
        outlined
        dense
        v-model="filter.query"
        placeholder="Search..."
        append-icon="fas fa-search"
        clearable
        clear-icon="fas fa-times"
        single-line
        hide-details
        @keyup="searchKeyUp()"
        @click:clear="searchKeyUp()"
      ></v-text-field>
      <v-btn
        class="ml-4"
        depressed
        color="secondary"
        @click="newClick"
        :disabled="!user.can('website.create')"
      >
    <v-icon
      small
      left
    >fas fa-folder-plus</v-icon>
    New
    </v-btn>
    </v-row>

    <v-data-table
      :class="{ 'clickable': user.can('website.update') }"
      :headers="headers"
      :items="items"
      :options.sync="options"
      :server-items-length="totalCount"
      :footer-props="{ 'items-per-page-options': [5, 10, 50] }"
      :loading="isSearching"
      @click:row="rowClick"
    >
    
      <template v-slot:item.is_unbranded="{ item }">
        <v-icon :color="item.is_unbranded ? 'secondary' : 'grey'" x-small>fas fa-circle</v-icon>
      </template>

    </v-data-table>


    <v-dialog
      v-model="dialog"
      max-width="700"
      persistent
    >
      <v-card>
        <v-toolbar color="primary" dark flat short class="px-2">
          <v-toolbar-title>Website</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn @click="dialog = false" icon><v-icon>fas fa-times</v-icon></v-btn>
        </v-toolbar>

        <v-card-text class="mt-12">
          <v-form @submit.prevent>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.name"
              :error-messages="errors.name"
              label="Name"
            ></v-text-field>

            <v-autocomplete
              outlined
              clearable
              clear-icon="fas fa-times"
              class="mb-2"
              v-model="model.website_profile_id"
              :error-messages="errors.website_profile_id"
              item-text="name"
              item-value="id"
              :items="websiteProfiles"
              label="Website Profile"
            ></v-autocomplete>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.api_url"
              :error-messages="errors.api_url"
              label="WooCommerce API url"
            ></v-text-field>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.api_key"
              :error-messages="errors.api_key"
              label="WooCommerce API key"
            ></v-text-field>

            <v-text-field
              outlined
              class="mb-2"
              v-model="model.api_secret"
              :error-messages="errors.api_secret"
              label="WooCommerce API secret"
            ></v-text-field>

          </v-form>
        </v-card-text>

        <v-card-actions class="px-6 pb-8">
          <v-btn
            color="error"
            class=""
            large
            outlined
            depressed
            @click="$refs.deleteWebsiteConfirmDialog.show()"
          >Delete</v-btn>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            class="px-5"
            large
            outlined
            depressed
            @click="dialog = false"
          >Cancel</v-btn>
          <v-btn
            color="primary"
            class="px-5"
            large
            depressed
            @click="saveClick()"
          >Save</v-btn>
        </v-card-actions>

        <ConfirmDialog
          ref="deleteWebsiteConfirmDialog"
          @confirm="deleteWebsite()"
          title="Confirm"
          message="This website will be deleted. Are you sure?"
          labelConfirm="OK"
          labelCancel="Cancel"
        ></ConfirmDialog>

      </v-card>

    </v-dialog>

  </v-card>
  
</template>

<script>
import { inject, ref } from 'vue'
import ConfirmDialog from '@/components/ConfirmDialog.vue'

export default {
  components: {
    ConfirmDialog,
  },
  setup() {
    const api = inject('api')
    const loader = inject('loader')
    const { user } = api

    const itemCollection = api.collection('websites', {
      params: {
        expand: 'website_profile',
      },
      filter: {
        query: 'query:code,name',
      },
      store: true,
    })

    const { items, filter, totalCount, options, isSearching } = itemCollection

    const websiteProfileCollection = api.collection('website-profiles')

    const { items: websiteProfiles } = websiteProfileCollection.all()


    const headers = [
      { text: 'Name', value: 'name' },
      { text: 'Website Profile', value: 'website_profile.name' },
    ]

    const dialog = ref(false)

    const itemModel = api.model('websites/:id', {
      params: {
      },
    })
    const { attributes: model, errors, isBusy } = itemModel

    loader.bindRef(isBusy)

    function newClick() {
      itemModel.clear().setAttributes({ status: 9 })
      dialog.value = true
    }

    function rowClick(item) {
      if (user.can('website.update')) {
        itemModel.find(item.id).then(() => {
          dialog.value = true
        })
      }
    }

    function saveClick() {
      itemModel.save().then(() => {
        itemCollection.search()
        dialog.value = false
      })
    }

    function deleteWebsite() {
      itemModel.delete().then(() => {
        itemCollection.search()
        dialog.value = false
      })
    }

    const searchKeyUp = itemCollection.debounceSearch(300)

    return {
      user,
      headers,
      items,
      filter,
      searchKeyUp,
      totalCount,
      options,
      isSearching,
      newClick,
      rowClick,
      saveClick,
      deleteWebsite,
      dialog,
      model,
      errors,
      websiteProfiles,
    }

  },
}
</script>


<style scoped>

:deep(.v-data-table.clickable table tbody tr:not(.v-data-table__empty-wrapper):hover) {
  cursor: pointer;
}

</style>
